import { EmploymentItemSkeleton } from '../../molecules/employment/skeletons/EmploymentItemSkeleton'

export const EmploymentListSkeleton = () => {
  return (
    <>
      {[1, 2, 3, 4, 5].map(value => (
        <EmploymentItemSkeleton key={value} first={value === 1} />
      ))}
    </>
  )
}
